{
  "CapabilitiesAffected": "Betroffene Funktionen:",
  "ShowRelated": "{relatedCount} ähnliche zeigen"
}
